import { render, staticRenderFns } from "./refundModal.vue?vue&type=template&id=8bf18fd4&scoped=true"
import script from "./refundModal.vue?vue&type=script&lang=js"
export * from "./refundModal.vue?vue&type=script&lang=js"
import style0 from "./refundModal.vue?vue&type=style&index=0&id=8bf18fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf18fd4",
  null
  
)

export default component.exports